/**
 * see file `.env`, can be overriden in `.env.{production,development}`
 * and their local counterparts
 */
export const BOOKMARK_OVERLAY_DISMISS_EXPIRE = parseInt(
  process.env.REACT_APP_BOOKMARK_OVERLAY_DISMISS_EXPIRE || '0',
  10
);

export const UK_COOKIE_EXPIRE = parseInt(
  process.env.REACT_APP_UK_COOKIE_EXPIRE || '0',
  10
);

export const BASE_URL = '';

export const SEARCH_URL = process.env.REACT_APP_SEARCH_URL || '';

export const SEARCH_IMAGE_URL = process.env.REACT_APP_SEARCH_IMAGE_URL || '';

export const SEARCH_VIDEO_URL = process.env.REACT_APP_SEARCH_VIDEO_URL || '';
export const SEARCH_VIDEOTHUMB_URL =
  process.env.REACT_APP_SEARCH_VIDEOTHUMB_URL || '';

export const TRACKING_HOST =
  process.env.REACT_APP_TRACKING_HOST ||
  `${window.location.protocol}//${window.location.host}`;

export const ACCESS_TYPO = process.env.REACT_APP_ACCESS_TYPO || '';

export const SELL_CAR_DATA_USE_DUMMY_DATA =
  process.env.REACT_APP_CAR_DATA_USE_DUMMY_DATA === 'yes';

export const MATOMO_TRACKER_ENABLED =
  process.env.REACT_APP_MATOMO_TRACKER_ENABLED === 'yes';

export const MATOMO_CONSENTLESS_MEDIA_TRACKING_ENABLED =
  process.env.REACT_APP_MATOMO_CONSENTLESS_MEDIA_TRACKING_ENABLED === 'yes';

export const GIT_COMMIT_HASH = process.env.REACT_APP_GIT_COMMIT_HASH || '';

export const defaultCurrency = 'EUR';

export const supportsServiceWorker = 'serviceWorker' in window.navigator;

export * from './locales';
